import { IUser, IUserInfo, USER_TYPE_ADMIN, USER_TYPE_USER } from '../mgs.types';
import { containsOnlyDigits, htmlOut, leftPad } from '@mng/mng-ts-helpers';
import { isHotelPartner } from '../partner/partner.helper';
import { isMgsSuperAdmin } from '../auth/auth.helper';

export function getNextUserId(partnerId: number, users: IUser[]): string {
  if (users?.length > 0) {
    const userIds: number[] = users
      .filter((user) => containsOnlyDigits(user.userId))
      .map((user) => {
        const userId = user.userId;
        return +userId;
      });

    const maxUserId = Math.max(...userIds);

    return (maxUserId + 1).toString();
  } else {
    return leftPad(`${partnerId}`, 3, '0') + '001';
  }
}

export function isSuperAdmin(user: IUser) {
  return USER_TYPE_ADMIN === user.userTypeId;
}

export function isAdminUser(user: IUser) {
  return USER_TYPE_ADMIN === user.userTypeId;
}

export function isNormalerUser(user: IUser) {
  return USER_TYPE_USER === user.userTypeId;
}

export function isSuperAdminUser(user: IUser): boolean {
  return isMgsSuperAdmin(user.authorities ?? []);
}

export function isUserRollenZuordnungMoeglich(user: IUser, isBuchungPartner: boolean) {
  return isNormalerUser(user) && user.partner && (isHotelPartner(user.partner) || isBuchungPartner);
}

export function userInfoAsString(user: IUserInfo): string {
  return `${user.name}`;
}

export function userInfoDetailAsString(user: IUserInfo): string {
  return `${user.name} (${user.userId} , ID: ${user.id})`;
}

export function userInfoHtmlDetailAsString(user: IUserInfo, mitPartnerInfo = false): string {
  const partnerInfo =
    mitPartnerInfo && user.partner
      ? `
        ${htmlOut('Partner', user.partner.name)}
        ${user.partner.betriebstellenkey ? htmlOut('BSK', user.partner.betriebstellenkey) : ''}
        ${htmlOut('Partner ID', user.partner.id)}
      `
      : '';

  return `<div style='min-width: 200px'>
          ${htmlOut('Name', user.name)}
          ${htmlOut('User ID', user.userId)}
          ${htmlOut('ID', user.id)}
          ${partnerInfo}
          </div>
`;
}
